import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SpecialtyDropdown from "../shared/SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";
import { MdnDispatchMode, KeepMdnMode, translateMdnValueGcpWire } from "../../utils/enums";

const EditOrg = ({ editObj, vendorId, closeEdit }) => {
  const navigate = useNavigate();
  const {
    userRole,
    userToken,
    sharedObject,
    SetSharedObject,
    XdrArr,
    backendTarget,
    userSession,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    XdrArr: state.XdrArr,
    backendTarget: state.backendTarget,
    userSession: state.userSession,
  }));
  const showOnDemandOption = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const [answers, setAnswers] = useState({
    MdnDispatchMode: MdnDispatchMode.Conditional,
    OrgClassificationCode: "CE",
    KeepMDN: KeepMdnMode.No,
  });
  const [orgValues, SetOrgValues] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  //const [errMsg, SetErrMsg] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const [colorMsg, SetColorMsg] = useState("danger");
  const [EnabledXDR, SetEnabledXDR] = useState(false);
  //const [CustomerCheckboxes, SetCustomerCheckboxes] = useState([]);
  //const [xdr, setXDR] = useState(false);
  const [customerPermissionsObj, SetCustomerPermissionsObj] = useState({});
  const [permissions, SetPermissions] = useState(true);
  const [specialtiesObj, setSpecialtiesObj] = useState({});
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const [phoneValidation, SetPhoneValidation] = useState(false);
  const [faxValidation, SetFaxValidation] = useState(false);

  const setAnswer = async (questionId, answer, chck) => {
    if (chck) {
      let obj = { ...answers };
      let add = answers.Addresses;
      add[questionId] = answer;
      obj.Addresses = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };

  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const buildForm = (frm) => {
    const listAddress = (frm) => {
      let o = {};
      if (frm?.addresses && frm?.addresses.length > 0) {
        let obj = frm?.addresses[0];
        o = {
          FirstLine: obj.firstLine,
          SecondLine: obj.secondLine,
          City: obj.city,
          State: obj.state,
          County: obj.secondLine,
          PostalCode: obj.postalCode,
          Country: obj.country,
          Phone: obj.phone.substring(0, 10),
          PhoneExt: obj.phone.substring(10, obj.phone.length),
          Fax: obj?.fax?.substring(0, 10),
          FaxExt: obj?.fax?.substring(10, obj.fax.length),
          AddressType: obj.addressType,
          IsCertAddress: obj.isCertAddress,
        };
      }
      return o;
    };

    const listSpecial = (frm) => {
      let o = [];
      if (frm?.specialties && frm?.specialties.length > 0) {
        let obj = frm?.specialties[0];
        o = [
          {
            Classification: obj.classification,
            Code: obj.code,
            Definition: obj.definition,
            Id: obj.id,
            Notes: obj.notes,
            Specialization: obj.specialization,
            Type: obj.type,
          },
        ];
      }
      return o;
    };

    const ListIds = (ob) => {
      let temp = [];
      if (ob && ob.length > 0) {
        for (let id of ob) {
          let obj = {
            RecordId: id.recordId,
            IDTypeString: id.idTypeString,
            IDType: id.idType,
            Value: id.value,
            IssuingAuthority: id.issuingAuthority,
          };
          temp.push(obj);
        }
      }

      return temp;
    };

    let ob = {
      AdminCount: frm?.adminCount,
      CredentialText: frm?.credentialText,
      DomainBox: "",
      DomainId: frm?.domainId,
      DomainName: frm?.domainName,
      ExternalId: frm?.externalId ? frm?.externalId : "",
      IDs: ListIds(frm?.iDs),
      Id: frm?.id,
      IsCsrOrg: frm?.isCsrOrg,
      IsEpicOrganization: frm?.isEpicOrganization,
      KeepMDN: typeof frm?.keepMDN === "boolean"
        ? (frm.keepMDN ? KeepMdnMode.Yes : KeepMdnMode.No)
        : frm?.keepMDN == null
        ? KeepMdnMode.No
        : showOnDemandOption
        ? translateMdnValueGcpWire(frm.keepMDN)
        : frm.keepMDN,
      NPI: frm?.npi,
      OrgEmailCount: frm?.orgEmailCount,
      OrganizationKind: frm?.organizationKind,
      OrganizationName: frm?.organizationName,
      OrganizationType: frm?.organizationType,
      ParentOrg: "",
      ParentOrganizationId: frm?.parentOrganizationId,
      ParentOrganizationName: frm?.parentOrganizationName,
      Specialties: listSpecial(frm),
      Addresses: listAddress(frm),
      SubOrgCount: frm?.subOrgCount,
      UserCount: frm?.userCount,
      UserEmailCount: frm?.userEmailCount,
      VendorId: frm?.vendorId,
      XDRDoNOTGenerateXDM: frm?.xdrDoNOTGenerateXDM,
      XDREnabled: frm?.xdrEnabled,
      xdrConfig: frm?.xdrConfig,
      OutboundXDRConfigName: frm?.xdrConfig?.id ? frm?.xdrConfig?.id : "",
      AllowTwoFactor: false,
      ApplicationAccessXDR: frm?.applicationAccessXDR,
      specializationCode: frm?.specializationCode,
      TwoFactorAuth: frm?.twoFactorAuth,
      ApplicationAccessENS: frm?.applicationAccessENS,
      EmailForwardingType: frm?.emailForwardingType,
      EmailForwardingTypeBox: frm?.emailForwardingType === 2 ? true : false,
      DirectRoute: frm?.emailForwardingType === 1 ? true : false,
      ShareDirectoryListing: frm?.shareDirectoryListing,
      GatewayModeEnabled: frm?.gatewayModeEnabled,
      MdnDispatchMode: frm?.mdnDispatchMode == null
        ? MdnDispatchMode.Conditional
        : showOnDemandOption
        ? translateMdnValueGcpWire(frm.mdnDispatchMode)
        : frm.mdnDispatchMode,
      OrgClassificationCode: frm?.orgClassificationCode ?? "CE",
    };

    if (ob.Addresses?.Phone != null) {
      ob.Addresses.Phone = formatPhoneNumber(frm.addresses[0].phone);
    }
    if (ob.Addresses?.Fax != null) {
      ob.Addresses.Fax = formatPhoneNumber(frm.addresses[0].fax);
    }
    SetEnabledXDR(frm?.xdrEnabled);
    if (frm?.xdrConfig?.id) {
      GetXdrConfig(frm?.xdrConfig.id);
    }
    setAnswers(ob);
    setSpecialtiesObj(ob.Specialties);
  };

  const [CustCheckboxes, SetCustCheckboxes] = useState({});
  const customerCheckboxes = (customerId) => {
    var customer = sharedObject.vendorsObj.find((element) => {
      return element.id === parseInt(customerId);
    });
    var ob = {
      EmailForwardingType: customer?.emailForwardingType,
      ApplicationAccessXDR: customer?.applicationAccessXDR,
      ApplicationAccessENS: customer?.applicationAccessENS,
      TwoFactorAuth: customer?.twoFactorAuth,
      ShareDirectoryListing: customer?.directorySharing,
      GatewayModeEnabled: customer?.gatewayModeEnabled,
    };
    SetCustCheckboxes(ob);
  };

  const ClearFields = async () => {
    buildForm(sharedObject.orgActionObj);
  };
  useEffect(() => {
    SetErrCreateMsg(false);
    const getOrgVals = async (val) => {
      SetSharedObject("xdrSettiingObj", {});
      SetProcessing(true);
      let call = "/organization/GetOrgValues?Type=" + val;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetOrgValues(res.data.data);
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
      SetProcessing(false);
    };
    getOrgVals("sub");
    buildForm(sharedObject.orgActionObj);
    SetCustomerPermissionsObj(sharedObject.CustomerPermissionsObj);
    //getXDREndPoints();
    customerCheckboxes(sharedObject?.orgActionObj?.vendorId);
    SetspecialtiesFlag(false);
    if (sharedObject?.xdrAdded) {
      GetXdrConfig(sharedObject.xdrAdded);
    }
    return () => {
      SetspecialtiesFlag(false);
      ClearFields();
      SetErrCreateMsg(false);
      SetSharedObject("xdrAdded", false);
    };
  }, [sharedObject.orgActionObj]);

  useEffect(() => {
    if (
      CustCheckboxes.EmailForwardingType === 0 &&
      CustCheckboxes.TwoFactorAuth === false &&
      CustCheckboxes.ApplicationAccessXDR === false &&
      CustCheckboxes.ApplicationAccessENS === false &&
      CustCheckboxes.ShareDirectoryListing === false &&
      CustCheckboxes.GatewayModeEnabled === false
    ) {
      SetPermissions(true);
    } else {
      SetPermissions(false);
    }
  }, [CustCheckboxes]);

  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const ValidatePhoneFax = (str) => {
    let nr = str.replace(/[^0-9]/g, "").substring(0, 10);
    return nr.length === 10;
  };
  const updateOrg = async () => {
    SetFrmSubmFlag(true);
    SetspecialtiesFlag(false);
    SetErrCreateMsg(false);
    // if (!answers.OrganizationKind) {
    //   document.getElementById("OrganizationKind").scrollIntoView();
    //   document.getElementById("OrganizationKind").focus();
    //   return;
    // } else
    if (!answers.Addresses?.FirstLine) {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (!answers.Addresses?.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.Addresses?.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.Addresses?.PostalCode) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (!answers.Addresses?.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    }
    if (answers.XDREnabled) {
      let flg = isEmpty(answers.xdrConfig.id);
      if (flg) {
        SetMsg("Please select an XDR Endpoint");
        SetErrCreateMsg(true);
        return;
      }
    }
    if (
      answers?.Addresses?.PostalCode?.length < 5 ||
      answers?.Addresses?.PostalCode?.length > 5
    ) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    }
    if (!ValidatePhoneFax(answers.Addresses.Phone)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      SetPhoneValidation(true);
      return;
    }
    if (
      !isEmpty(answers.Addresses.Fax) &&
      !ValidatePhoneFax(answers.Addresses.Fax)
    ) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      SetFaxValidation(true);
      return;
    }
    SetFrmSubmFlag(false);
    let PhoneExtNr = !isEmpty(answers.Addresses.PhoneExt)
      ? answers.Addresses.PhoneExt
      : "";
    answers.Addresses.Phone =
      answers.Addresses.Phone.replace(/[^0-9]/g, "").substring(0, 10) +
      PhoneExtNr;

    let FaxNr = answers.Addresses.Fax
      ? answers.Addresses.Fax.replace(/[^0-9]/g, "").substring(0, 10)
      : "";
    let FaxExtNr = !isEmpty(answers.Addresses.FaxExt)
      ? answers.Addresses.FaxExt
      : "";
    if (!isEmpty(FaxNr)) {
      answers.Addresses.Fax = `${FaxNr}${FaxExtNr}`;
    } else {
      answers.Addresses.Fax = "";
    }

    answers.Addresses = [answers.Addresses];

    let specCode = null;
    if (answers.specializationCode) {
      specCode = answers.specializationCode;
    } else {
      answers.Specialties = [];
    }
    if (answers?.xdrConfig?.id) {
      let xdr = answers.xdrConfig;
      let xConfig = {
        ClientCertificate: xdr.clientCertificate,
        ClientCertificateFindValue: xdr.clientCertificateFindValue,
        EndpointAddress: xdr.endpointAddress,
        EndpointName: xdr.endpointName,
        Id: xdr.id,
        IsValid: xdr.isValid,
        MDNForward: xdr.mdnForward,
        SendXDMBody: xdr.sendXDMBody,
        OrganizationId: xdr.organizationId,
        SchemaValidateRequest: xdr.schemaValidateRequest,
        SchemaValidateResponse: xdr.schemaValidateResponse,
        SchemaValidatorOn: xdr.schemaValidatorOn,
        UseConfigFile: xdr.useConfigFile,
      };

      answers.xdrConfig = xConfig;
    }
    SetProcessing(true);
    var finalAnswers = answers;
    finalAnswers.EmailForwardingType = EmailForwardingType;
    let sCode = specCode ? specCode : "Empty";
    let call =
      "/organization/CreateUpdateOrganization?specializationCode=" + sCode;
    const payload = {
      ...finalAnswers,
      KeepMDN: showOnDemandOption
        ? translateMdnValueGcpWire(finalAnswers.KeepMDN)
        : finalAnswers.KeepMDN !== 0,
      MdnDispatchMode: showOnDemandOption
        ? translateMdnValueGcpWire(finalAnswers.MdnDispatchMode)
        : finalAnswers.MdnDispatchMode,
    };
    const res = await CallAPI(call, payload, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let temp = [];
      sharedObject.getOrgsObj.map((el) => {
        if (el.id === finalAnswers.Id) {
          el.twoFactorAuth = finalAnswers.TwoFactorAuth;
          el.xdrDoNOTGenerateXDM = finalAnswers.XDRDoNOTGenerateXDM;
          el.shareDirectoryListing = finalAnswers.ShareDirectoryListing;
          el.applicationAccessENS = finalAnswers.ApplicationAccessENS;
          el.applicationAccessXDR = finalAnswers.ApplicationAccessXDR;
        }
        temp.push(el);
      });
      SetSharedObject("getOrgsObj", temp);
      SetProcessing(false);
      closeEdit(answers);
      CloseModal();
    } else if (
      res.status === "SERVERERROR" ||
      res.status === "REGISTRATIONERROR"
    ) {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetColorMsg("danger");
      SetProcessing(false);
      answers.Addresses = answers.Addresses[0];
      //$(".modal").modal("hide");
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };
  const GetXdrConfig = (vl) => {
    let temp = {};
    for (let el of XdrArr) {
      if (el.id === parseInt(vl)) {
        temp = el;
        break;
      }
    }
    SetSharedObject("xdrSettiingObj", temp);
    setAnswers({ ...answers, xdrConfig: temp, OutboundXDRConfigName: vl });
  };
  const handleXDR = () => {
    GetXdrConfig(answers.xdrConfig.id);
    $("#xdrSettingModal").modal("show");
  };
  const [EmailForwardingType, SetEmailForwardingType] = useState(0);
  const setDirectRoute = (val) => {
    if (val === true) {
      SetEmailForwardingType(1);
    } else {
      SetEmailForwardingType(0);
    }
    setAnswer("DirectRoute", val);
  };

  const setAdvancedDirectRoute = (val) => {
    if (val === true) {
      SetEmailForwardingType(2);
    } else {
      SetEmailForwardingType(0);
    }
    setAnswer("EmailForwardingTypeBox", val);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
      $('#editOrgModal').modal('hide');
};

  return (
    <div className="EditOrg">
      <div
        className="modal fade"
        data-backdrop="false"
        id="editOrgModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editOrgModalTitle"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="editOrgModalTitle"
                tabIndex={0}
              >
                Organization Edit
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close Edit Organization"
                onClick={(e) => {
                  SetErrCreateMsg(false);
                  ClearFields();
                  CloseModal();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form className="needs-validation" noValidate aria-label="Edit Organization Details">
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header">
                    <i className="bi bi-building-fill text-size5 blk-clr" aria-hidden="true"></i>
                    <div className="text-size6 ft-wt blk-clr spacer-margin7">
                      {answers?.OrganizationName}
                    </div>
                  </div>
                  <hr />
                  {/*Org Type*/}
                  {/*<div className="field-wrapper">*/}
                  {/*  <label htmlFor="OrgType">Organization Type</label>*/}
                  {/*  <select*/}
                  {/*    className="form-control"*/}
                  {/*    name="OrganizationKind"*/}
                  {/*    id="OrganizationKind"*/}
                  {/*    value={answers?.OrganizationKind}*/}
                  {/*    onChange={(el) =>*/}
                  {/*      setAnswer("OrganizationKind", parseInt(el.target.value))*/}
                  {/*    }*/}
                  {/*  >*/}
                  {/*    <option value="">Select</option>*/}
                  {/*    {orgValues?.getOrgKinds?.value.data.map((el) => (*/}
                  {/*      <option key={el.id} value={el.id}>*/}
                  {/*        {el.name}*/}
                  {/*      </option>*/}
                  {/*    ))}*/}
                  {/*  </select>*/}
                  {/*  {answers?.OrganizationKind === "" && frmSubmFlag ? (*/}
                  {/*    <div className="alert alert-danger"> Required! </div>*/}
                  {/*  ) : null}*/}
                  {/*</div>*/}
                  {/*Contact Information*/}
                  {/*<div className="field-wrapper title-divider">*/}
                  {/*  Contact Information*/}
                  {/*</div>*/}
                  <div className="field-wrapper">
                    <label htmlFor="FirstLine">Address 1
                      <span className="sr-only">(required)</span>
                    </label>
                    <input
                      className="form-control"
                      name="FirstLine"
                      id="FirstLine"
                      autoComplete="address-line1"
                      aria-required="true"
                      aria-describedby={
                        !answers?.Addresses?.FirstLine && frmSubmFlag
                          ? "firstLineError"
                          : undefined
                      }
                      value={answers?.Addresses?.FirstLine}
                      onChange={(el) =>
                        setAnswer("FirstLine", el.target.value, true)
                      }
                    />
                    {!answers?.Addresses?.FirstLine && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" id="firstLineError" aria-live="polite">
                        Address is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 2*/}
                  <div className="field-wrapper">
                    <label htmlFor="SecondLine">Address 2</label>
                    <input
                      className="form-control"
                      name="SecondLine"
                      id="SecondLine"
                      autoComplete="address-line2"
                      placeholder="Optional"
                      value={answers?.Addresses?.SecondLine}
                      onChange={(el) =>
                        setAnswer("SecondLine", el.target.value, true)
                      }
                    />
                  </div>
                  <div className="field-wrapper">
                    <label htmlFor="City">City
                      <span className="sr-only">(required)</span>
                    </label>
                    <input
                      className="form-control"
                      name="City"
                      id="City"
                      autoComplete="address-level2"
                      aria-describedby={
                        !answers?.Addresses?.City && frmSubmFlag
                          ? "cityError"
                          : undefined
                      }
                      value={answers?.Addresses?.City}
                      onChange={(el) =>
                        setAnswer("City", el.target.value, true)
                      }
                      disabled
                    />
                    {!answers?.Addresses?.City && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger" role="alert" id="cityError" aria-live="polite">
                          City is required.
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper">
                    {/*State*/}
                    <div className="org-contact-wrapper field-ext">
                      <label htmlFor="edit-org-state">
                        State <span className="sr-only">(required)</span>
                     </label>
                      <select
                        className="form-control"
                        name="State"
                        id="edit-org-state"
                        aria-required="true"
                        aria-describedby={
                          !answers?.Addresses?.State && frmSubmFlag
                            ? "stateError"
                            : undefined
                        }
                        value={answers?.Addresses?.State}
                        onChange={(el) =>
                          setAnswer("State", el.target.value, true)
                        }
                        disabled
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*Zip Code*/}
                    <div className="org-contact-wrapper field-ext">
                      <label htmlFor="PostalCode">
                        Zip <span className="sr-only">(required)</span>
                      </label>
                      <input
                        className="form-control"
                        id="PostalCode"
                        name="PostalCode"
                        autoComplete="postal-code"
                        maxLength={5}
                        aria-required="true"
                        aria-describedby={
                          !answers?.Addresses?.PostalCode && frmSubmFlag
                            ? "postalError"
                            : undefined
                        }
                        value={answers?.Addresses?.PostalCode}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                          setAnswer("PostalCode", onlyNums, true);
                        }}
                      />
                    </div>
                    {!answers?.Addresses?.State && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger" role="alert" id="stateError" aria-live="polite">
                          State is required.
                        </div>
                      </div>
                    ) : null}
                    {!answers?.Addresses?.PostalCode && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger" role="alert" id="postalError" aria-live="polite">
                          Zip Code is required.
                        </div>
                      </div>
                    ) : null}
                    {answers?.Addresses?.PostalCode &&
                    answers?.Addresses?.PostalCode?.length < 5 &&
                    frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger" role="alert" id="postalError" aria-live="polite">
                          Invalid Zip Code
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {/*Phone*/}
                  <div className="field-wrapper ">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Phone">
                        Phone <span className="sr-only">(required)</span>
                      </label>
                      <input
                        className="form-control"
                        id="Phone"
                        name="phone"
                        type="tel"
                        autoComplete="tel"
                        aria-required="true"
                        aria-describedby={
                          (!answers?.Addresses?.Phone && frmSubmFlag) ||
                          (answers?.Addresses?.Phone?.length < 14 && frmSubmFlag)
                            ? "phoneError"
                            : undefined
                        }
                        value={formatPhoneNumber(answers?.Addresses?.Phone)}
                        onChange={(el) =>
                          setAnswer("Phone", el.target.value, true)
                        }
                      />
                      {!answers?.Addresses?.Phone && frmSubmFlag ? (
                        <div className="alert alert-danger" id="phoneError" role="alert" aria-live="polite">
                          Phone number is required.
                        </div>
                      ) : null}
                      {answers?.Addresses?.Phone &&
                      answers?.Addresses?.Phone?.length < 14 &&
                      frmSubmFlag ? (
                        <div className="alert alert-danger" id="PhoneError" role="alert" aria-live="polite">
                          Invalid Phone Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="PhoneExt">Ext</label>
                      <input
                        className="form-control"
                        id="PhoneExt"
                        name="PhoneExt"
                        autoComplete="tel-extension"
                        maxLength={6}
                        value={answers?.Addresses?.PhoneExt}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                          setAnswer("PhoneExt", onlyNums, true);
                        }}
                      />
                    </div>
                  </div>
                  {/*Fax*/}
                  <div className="field-wrapper">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Fax">Fax</label>
                      <input
                        className="form-control"
                        id="Fax"
                        name="Fax"
                        type="tel"
                        autoComplete="off"
                        placeholder="Optional"
                        aria-describedby={
                          answers?.Addresses?.Fax?.length < 14 &&
                          frmSubmFlag &&
                          answers?.Addresses?.Fax.length > 0
                            ? "faxError"
                            : undefined
                        }
                        value={formatPhoneNumber(answers?.Addresses?.Fax)}
                        onChange={(el) =>
                          setAnswer("Fax", el.target.value, true)
                        }
                      />
                      {answers?.Addresses?.Fax?.length < 14 &&
                      frmSubmFlag &&
                      answers?.Addresses?.Fax.length > 0 ? (
                        <div className="alert alert-danger" id="faxError" role="alert" aria-live="polite">
                          Invalid Fax Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="FaxExt">Ext</label>
                      <input
                        className="form-control"
                        id="FaxExt"
                        name="FaxExt"
                        autoComplete="off"
                        maxLength={6}
                        value={answers?.Addresses?.FaxExt}
                        disabled={
                          answers?.Addresses?.Fax?.replace(/[^0-9]/g, "")
                            .length === 0
                        }
                        aria-describedby="FaxExtHint"
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                          setAnswer("FaxExt", onlyNums, true);
                        }}
                      />
                      <span id="FaxExtHint" className="sr-only">
                        Fax extension is only available after a fax number is entered.
                      </span>
                    </div>
                  </div>
                  {/*External ID*/}
                  <div className="field-wrapper">
                    <label htmlFor="ExternalId">External ID</label>
                      <input
                        type="text"
                        className="form-control"
                        id="ExternalId"
                        name="ExternalId"
                        placeholder="Optional"
                        autoComplete="off"
                        value={answers?.ExternalId}
                        onChange={(el) =>
                          setAnswer("ExternalId", el.target.value)
                        }
                      />
                  </div>
                  {/*Organization Classification*/}
                  <div className="field-wrapper">
                    <label htmlFor="OrgClassificationCode">
                      Organization Classification
                      <span className="sr-only">(required)</span>
                    </label>
                    <select
                      className="form-control"
                      id="OrgClassificationCode"
                      name="OrgClassificationCode"
                      value={answers?.OrgClassificationCode ?? "CE"}
                      onChange={(el) =>
                        setAnswer("OrgClassificationCode", el.target.value)
                      }
                      aria-required="true"
                    >
                      {sharedObject?.orgClassifications?.map((el) => (
                        <option key={el.code} value={el.code}>
                          {el.name} ({el.code})
                        </option>
                      ))}
                    </select>
                  </div>
                  {/*Specialty*/}
                  <h6 className="field-wrapper title-divider sp-pad9" id="specialtyTitle">Specialty</h6>
                  <div className="field-wrapper text-reg">
                    This section is optional but we highly recommend you select
                    these options to identify specific areas of focus in the
                    organization.{" "}
                    <strong className="or-clr">
                      If you select a type, then you must select both
                      classification and specialization.
                    </strong>
                  </div>

                  <SpecialtyDropdown
                    SpecialFormFields={(el, val) => SpecialFormFields(el, val)}
                    codes={orgValues?.codes}
                    editObj={specialtiesObj}
                  />
                  {specialtiesFlag && frmSubmFlag ? (
                    <div className="alert alert-danger" id="SpecialtyId" role="alert">
                      Specialization is required when you are selecting Type or
                      Classification.
                    </div>
                  ) : null}

                  {/*Email Delivery*/}
                  <h6 className="field-wrapper title-divider sp-pad9" id="emailDeliveryTitle">
                    Email Delivery
                  </h6>
                  <div className="field-wrapper spacer-inline spacer-margin1">
                    <label htmlFor="KeepMDN">Keep MDN</label>
                    <br />
                    <select
                      className="form-control w-md3 spacer-inline"
                      name="KeepMDN"
                      id="KeepMDN"
                      value={answers?.KeepMDN}
                      onChange={(el) =>
                        setAnswer("KeepMDN", parseInt(el.target.value))
                      }
                    >
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                      {showOnDemandOption && <option value="2">On Demand</option>}
                    </select>
                  </div>
                  <div className="field-wrapper spacer-inline">
                    <label htmlFor="SendMDN">Send Dispatched MDN</label>
                    <br />
                    <select
                      className="form-control w-md3 spacer-inline"
                      name="SendMDN"
                      id="SendMDN"
                      value={answers.MdnDispatchMode}
                      onChange={(el) =>
                        setAnswer("MdnDispatchMode", parseInt(el.target.value))
                      }
                    >
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                      {showOnDemandOption && <option value="2">On Demand</option>}
                    </select>
                  </div>

                  {userRole !== "SES ADMINISTRATOR" &&
                  userRole !== "SYSTEMADMINISTRATOR" ? (
                    <div className="field-wrapper">
                      {CustCheckboxes.ApplicationAccessXDR &&
                      answers.ApplicationAccessXDR ? (
                        <>
                          <label htmlFor="XDRDoNOTGenerateXDM-1">Outbound XDR</label>
                          <section>
                            <input
                              className="form-control spacer-margin5"
                              type="checkbox"
                              name="XDRDoNOTGenerateXDM"
                              id="XDRDoNOTGenerateXDM-1"
                              checked={!answers?.XDRDoNOTGenerateXDM}
                              value={!answers?.XDRDoNOTGenerateXDM}
                              onChange={(el) =>
                                setAnswer(
                                  "XDRDoNOTGenerateXDM",
                                  !el.target.checked
                                )
                              }
                            />
                            <span htmlFor="xdmDelivery" className="label-sub">
                              XDM Delivery
                            </span>
                            <button
                              type="button"
                              data-target="#xdmDelivery"
                              data-toggle="collapse"
                              className="btn btn-link sp-pad0 sm-icon-container"
                              aria-expanded="false"
                              aria-controls="xdmDelivery"
                              aria-label="XDM Deliver More Information"
                            >
                              <i className="bi bi-plus-lg" aria-hidden="true"></i>
                            </button>
                            <div
                              className="collapse text-reg sub-catg"
                              id="xdmDelivery"
                            >
                              If checked, message delivered over XDR will be
                              packaged as Direct message with XDM attachment.
                              Please make sure your recipients can accept and
                              handle XDM.
                            </div>
                          </section>
                        </>
                      ) : null}
                    </div>
                  ) : (
                    <>
                      {/*Inbound XDR*/}
                      <div>
                        {CustCheckboxes.ApplicationAccessXDR &&
                        answers?.ApplicationAccessXDR ? (
                          <>
                            <hr />
                            <div className="field-wrapper sp-pad7">
                              <label htmlFor="XDREnabled">
                                Inbound XDR:
                              </label>
                              <input
                                className="form-control spacer-margin2"
                                type="checkbox"
                                id="XDREnabled"
                                name="XDREnabled"
                                value={answers?.XDREnabled}
                                checked={answers?.XDREnabled}
                                onChange={(el) =>
                                  setAnswer("XDREnabled", el.target.checked)
                                }
                              />
                              <select
                                className="form-control w-lg6 spacer-inline"
                                name="OutboundXDRConfigName"
                                value={answers?.OutboundXDRConfigName}
                                onChange={(el) => {
                                  SetSharedObject("xdrAdded", false);
                                  GetXdrConfig(el.target.value);
                                }}
                                disabled={!answers?.XDREnabled}
                                aria-disabled={!answers?.XDREnabled}
                              >
                                <option value="">
                                  Add or Select XDR Configuration
                                </option>
                                {XdrArr?.map((el) => (
                                  <option key={el.id} value={el.id}>
                                    {el.endpointName}
                                  </option>
                                ))}
                              </select>
                              <button
                                type="button"
                                className="btn btn-primary spacer-margin2"
                                onClick={(el) => handleXDR()}
                                disabled={!answers?.XDREnabled}
                                aria-label="Configure XDR Settings"
                              >
                                <i className="bi bi-gear" aria-hidden="true"></i>
                              </button>
                            </div>
                          </>
                        ) : null}
                        <div className="field-wrapper">
                          {CustCheckboxes.ApplicationAccessXDR === true &&
                          answers?.ApplicationAccessXDR ? (
                            <span className="custom-label">Outbound XDR</span>
                          ) : null}
                          {CustCheckboxes.ApplicationAccessXDR === true &&
                          answers?.ApplicationAccessXDR ? (
                            <>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="IsEpicOrganization"
                                  id="IsEpicOrganization"
                                  checked={answers?.IsEpicOrganization}
                                  value={answers?.IsEpicOrganization}
                                  onChange={(el) =>
                                    setAnswer(
                                      "IsEpicOrganization",
                                      el.target.checked
                                    )
                                  }
                                />
                                <span htmlFor="IsEpicOrganization" className="label-sub">
                                  Create Direct Automatically
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-link sp-pad0 sm-icon-container"
                                  data-target="#CreateDirect"
                                  data-toggle="collapse"
                                  aria-expanded="false"
                                  aria-controls="CreateDirect"
                                  aria-label="Create Direct Automatically More Information"
                                >
                                  <i className="bi bi-plus-lg" aria-hidden="true"></i>
                                </button>
                                <div
                                  className="collapse text-reg sub-catg"
                                  id="CreateDirect"
                                >
                                  Emails are created in the organization
                                  according to the certificate used to
                                  authenticate the INBOUND connection.
                                </div>
                              </section>
                            </>
                          ) : null}
                          {CustCheckboxes.ApplicationAccessXDR &&
                          answers?.ApplicationAccessXDR ? (
                            <section>
                              <input
                                className="form-control spacer-margin5"
                                type="checkbox"
                                name="XDRDoNOTGenerateXDM"
                                id="XDRDoNOTGenerateXDM"
                                checked={!answers?.XDRDoNOTGenerateXDM}
                                value={!answers?.XDRDoNOTGenerateXDM}
                                onChange={(el) =>
                                  setAnswer(
                                    "XDRDoNOTGenerateXDM",
                                    !el.target.checked
                                  )
                                }
                              />
                              <span htmlFor="XDRDoNOTGenerateXDM" className="label-sub">
                                XDM Delivery
                              </span>
                              <button
                               type="button"
                               className="btn btn-link sp-pad0 sm-icon-container"
                               data-target="#xdmDelivery"
                                data-toggle="collapse"
                                aria-expanded="false"
                                aria-controls="xdmDelivery"
                                aria-label="XDM Delivery More Information"
                              >
                                <i className="bi bi-plus-lg" aria-hidden="true"></i>
                              </button>
                              <div
                                className="collapse text-reg sub-catg"
                                id="xdmDelivery"
                              >
                                If checked, message delivered over XDR will be
                                packaged as Direct message with XDM attachment.
                                Please make sure your recipients can accept and
                                handle XDM.
                              </div>
                            </section>
                          ) : null}
                        </div>
                      </div>

                      <h6 className="field-wrapper title-divider sp-pad9" id="permissionsTitle">
                        Permissions
                      </h6>

                      <div className="field-wrapper">
                        {/*Two Factor Enable and Disable*/}
                        {permissions === true ? (
                          <div className="sub-catg ctr">
                            There are no permissions for this organization.
                          </div>
                        ) : null}

                        {CustCheckboxes.TwoFactorAuth ? (
                          <div>
                            <section>
                              <input
                                className="form-control spacer-margin5"
                                type="checkbox"
                                name="AllowTwoFactor"
                                id="AllowTwoFactor"
                                checked={answers?.TwoFactorAuth}
                                value={answers?.TwoFactorAuth}
                                onChange={(el) =>
                                  setAnswer("TwoFactorAuth", el.target.checked)
                                }
                              />
                              <label htmlFor="AllowTwoFactor">Two Factor Authentication</label>
                                <button
                                  type="button"
                                  className="btn btn-link sp-pad0 sm-icon-container"
                                  data-toggle="collapse"
                                  data-target="#twoFactorInfo-1"
                                  aria-expanded="false"
                                  aria-controls="TwoFactorInfo"
                                  aria-describedby="twoFactorInfo-1"
                                >
                                   <i className="bi bi-plus-lg" aria-hidden="true"></i>
                                </button>

                            </section>
                            <section
                              className="collapse text-reg"
                              id="twoFactorInfo-1"
                            >
                              Two-factor authentication improves your digital
                              security by protecting your account with an
                              additional login step. It makes it harder for
                              unauthorized users to gain access to an account
                              without permission.{" "}
                              <strong>
                                Selecting the checkbox at the organization level
                                will enable two-factor authentication settings
                                for all users within this organization.
                                Deselecting the checkbox will disable them.
                              </strong>
                            </section>
                          </div>
                        ) : null}
                        {/*End Two Factor*/}

                        {/*XDR Access Enable and Disable*/}

                        {CustCheckboxes.ApplicationAccessXDR ? (
                          <div>
                            <section>
                              <input
                                className="form-control spacer-margin5"
                                type="checkbox"
                                name="ApplicationAccessXDR"
                                id="ApplicationAccessXDR"
                                checked={answers?.ApplicationAccessXDR}
                                value={answers?.ApplicationAccessXDR}
                                onChange={(el) =>
                                  setAnswer(
                                    "ApplicationAccessXDR",
                                    el.target.checked
                                  )
                                }
                              />
                              <label htmlFor="ApplicationAccessXDR">XDR-Access</label>
                            </section>
                          </div>
                        ) : null}

                        <div>
                          {/*Notify Enable or Disable*/}
                          {CustCheckboxes.ApplicationAccessENS ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="ApplicationAccessENS"
                                  id="ApplicationAccessENS"
                                  checked={answers?.ApplicationAccessENS}
                                  value={answers?.ApplicationAccessENS}
                                  onChange={(el) =>
                                    setAnswer(
                                      "ApplicationAccessENS",
                                      el.target.checked
                                    )
                                  }
                                />
                                <label htmlFor="ApplicationAccessENS">Notify</label>
                              </section>
                            </div>
                          ) : null}
                          {/*DirectRoute Enable or Disable*/}
                          {CustCheckboxes.EmailForwardingType &&
                          CustCheckboxes.EmailForwardingType === 1 ? (
                            <>
                              <div>
                                <section>
                                  <input
                                    className="form-control spacer-margin5"
                                    type="checkbox"
                                    name="DirectRoute"
                                    id="DirectRoute"
                                    checked={answers?.DirectRoute}
                                    value={answers?.DirectRoute}
                                    onChange={(el) =>
                                      setDirectRoute(el.target.checked)
                                    }
                                  />
                                  <label htmlFor="DirectRoute">DirectRoute</label>
                                </section>
                              </div>
                            </>
                          ) : null}
                          {CustCheckboxes.EmailForwardingType &&
                          CustCheckboxes.EmailForwardingType === 2 ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="AdvancedDirectRoute"
                                  id="AdvancedDirectRoute"
                                  checked={answers?.EmailForwardingTypeBox}
                                  value={answers?.EmailForwardingTypeBox}
                                  onChange={(el) =>
                                    setAdvancedDirectRoute(el.target.checked)
                                  }
                                />
                                <label htmlFor="AdvancedDirectRoute">Advanced DirectRoute</label>
                              </section>
                            </div>
                          ) : null}

                          {/*Share Directory Listing Enable or Disable*/}

                          {CustCheckboxes.ShareDirectoryListing ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="ShareDirectoryListing"
                                  id="ShareDirectoryListing"
                                  checked={answers?.ShareDirectoryListing}
                                  value={answers?.ShareDirectoryListing}
                                  onChange={(el) =>
                                    setAnswer(
                                      "ShareDirectoryListing",
                                      el.target.checked
                                    )
                                  }
                                />
                                <label htmlFor="ShareDirectoryListing">Share Directory Listing</label>
                              </section>
                            </div>
                          ) : null}
                          {CustCheckboxes.GatewayModeEnabled ? (
                            <div>
                              <section>
                                <input
                                  className="form-control spacer-margin5"
                                  type="checkbox"
                                  name="GatewayModeEnabled"
                                  id="GatewayModeEnabled"
                                  checked={answers?.GatewayModeEnabled}
                                  value={answers?.GatewayModeEnabled}
                                  onChange={(el) =>
                                    setAnswer(
                                      "GatewayModeEnabled",
                                      el.target.checked
                                    )
                                  }
                                />
                                <label htmlFor="GatewayModeEnabled">Gateway Mode</label>
                              </section>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )}
                  {errCreateMsg ? (
                    <div 
                        className={`alert alert-${colorMsg}`} 
                        role="alert"
                        aria-live="assertive">
                      {msg}
                    </div>
                  ) : null}
                </div>

              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updateOrg}
                  aria-busy={processing}
                  disabled={processing}
                >
                  {processing ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  aria-label="Cancel and close the edit organization form"
                  disabled={processing}
                  onClick={(e) => {
                    SetFrmSubmFlag(false);
                    SetPhoneValidation(false);
                    SetFaxValidation(false);
                    ClearFields();
                    SetErrCreateMsg(false);
                    CloseModal();
                  }}
                >
                  Cancel
                </button>
              </div>
                {processing && (
                <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="edit-org-loader"
                >
                    <div className="spinner" aria-hidden="true"></div>
                    <div className="loading-text" id="edit-org-loader">{loadingText}</div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrg;
